/**
 * Extrai mensagem de erro quando a API devolve JSON com responseType: 'blob'
 * (ex.: 403/500), padrão usado nos exports Excel do backoffice.
 */
export default async function parseBlobError(
  error: any,
  fallbackMessage: string
): Promise<never> {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    let message = fallbackMessage;
    try {
      const text = await data.text();
      const json = JSON.parse(text);
      message = json?.errors?.[0] ?? json?.message ?? fallbackMessage;
    } catch {
      // Blob não é JSON legível — mantém fallback
    }
    throw new Error(typeof message === 'string' ? message : fallbackMessage);
  }

  const message =
    error?.response?.data?.errors?.[0] ??
    error?.response?.data?.message ??
    error?.message ??
    fallbackMessage;
  throw new Error(typeof message === 'string' ? message : fallbackMessage);
}
